<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()

const { documents, startPrice } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <tr>
    <td>
      <SectionsDetailsElementsParameters :parameters="details.documents">
        <template #before>
          <thead>
            <SectionsDetailsPdfElementsHeading colspan="2" as="th">
              {{ documents.title }}
            </SectionsDetailsPdfElementsHeading>
          </thead>
        </template>

        <template #after>
          <tr v-if="startPrice?.priceLabel" class="text-primaryDark">
            <td class="pt-4 text-xl font-bold">
              {{ startPrice.priceLabel }}:
            </td>
            <td class="pt-4 text-xl">
              <CommonCalculatedPrice
                class="font-bold"
                :price="startPrice.price"
              />
            </td>
          </tr>
          <tr v-if="startPrice?.taxLabel">
            <td class="text-xl font-bold">
              {{ startPrice.taxLabel }}:
            </td>
            <td class="text-xl font-bold">
              {{ startPrice.tax }}
            </td>
          </tr>
        </template>
      </SectionsDetailsElementsParameters>
    </td>
  </tr>
</template>
